export const PENDING = 'pending'
export const REJECTED = 'rejected'
export const ACCEPTED = 'accepted'

export const FILTER_NAME = 'contract'
